<script>
  import Multiselect from 'vue-multiselect'
  import {
    generateId,
  } from '../plugins/utils.js'

  export default {
    name: 'FabricSelect',
    components: {
      Multiselect,
    },
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: {
        type: null,
        required: true,
      },
      id: {
        type: [String, Number],
        default: (() => generateId()),
      },
      getData: {
        type: null,
        default: null,
      },
      label: {
        type: String,
        default: 'name',
      },
      trackBy: {
        type: String,
        default: 'id',
      },
      timeoutDuration: {
        type: Number,
        default: 1000,
      },
      customLabel: {
        type: Function,
        default (option, label) {
          if (!option) return ''
          return label ? option[label] : option
        },
      },
      noSearchInitial: {
        type: Boolean,
        default: false,
      },
      disallowEmpty: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: 'Select option',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        model: this.value,
        options: [],
        isLoading: false,
        latestSearchTime: 0,
        searchTimeout: null,
      }
    },
    watch: {
      model (val) {
        this.$emit('change', val)
      },
      value (newVal) {
        // watcher added to support upstream changes to value to propogate down
        // i.e. parent obj changes bound this.value, reactivly updated selected obj
        this.$set(this, 'model', newVal)
      },
    },
    async created() {
      if (this.noSearchInitial) {
        return
      }
      return this.tryToSearch()
    },
    methods: {
      async search (query = '', time = 0) {
        if (typeof this.getData !== 'function') {
          return
        }
        this.isLoading = true
        const { data } = await this.getData({
          search: query
        })
        if (time < this.latestSearchTime) {
          this.isLoading = false
          return
        }
        
        this.options = data.data
          
        this.isLoading = false
      },
      async tryToSearch (query = '') {
        this.latestSearchTime = (new Date()).getTime()
        if (this.timeoutDuration > 1){
          clearTimeout(this.searchTimeout)
          this.searchTimeout = setTimeout(() => this.search(query, this.latestSearchTime), this.timeoutDuration)
        }else{
          this.search(query, this.latestSearchTime)
        }
      },
    }
  }
</script>

<template>
  <article :id="id + '__fb_select__'">
    <Multiselect
      v-model="model"
      v-bind="$attrs"
      class="bind-width"
      :class="{
        'scrollable': options.length > 7,
      }"
      :multiple="false"
      :options="options"
      :label="label"
      :track-by="trackBy"
      :custom-label="customLabel"
      :loading="isLoading"
      :internal-search="false"
      :allow-empty="!disallowEmpty"
      :placeholder="placeholder"
      :disabled="disabled"
      @search-change="tryToSearch"
    />
  </article>
</template>
